<template>
  <Dialogs :dialog="dialog" :handleClose="close">
    <template #content>
        <div class="dialog_content">
          <el-form v-if="!isUpdatePassword" ref="form" :model="form" :rules="rules" label-width="100px" size="small">
            <el-form-item label="姓名" prop="name" class="inlinitem">
              <el-input style="width:405px;" maxlength="100" v-model="form.name" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="性别" prop="sex">
              <el-select
                v-model="form.sex"
                clearable
                @change="changeSelect"
                placeholder="请选择"
                style="width:405px;"
                >
                <el-option label="男" :value="1"> </el-option>
                <el-option label="女" :value="0"> </el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="手机号" prop="phone">
              <el-input style="width:405px;" maxlength="100" v-model="form.phone" placeholder="请输入"></el-input>
            </el-form-item>
            <!-- <el-form-item label="手机号" prop="loginName">
              <el-input style="width:405px;" maxlength="100" v-model="form.loginName" placeholder="请输入"></el-input>
            </el-form-item> -->

            <el-form-item label="密码" prop="password" v-if="data.title!='修改'">
              <el-input style="width:405px;" :type="passwordType" maxlength="100" v-model="form.password" placeholder="请输入">
                <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="审核权限">
              <el-checkbox-group v-model="type">
                <!-- <el-checkbox label="一级审核" name="type"></el-checkbox> -->
                <el-checkbox label="审核" name="type"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <!-- <el-form-item label="手机号" prop="phone">
              <el-input style="width:405px;" maxlength="100" v-model="form.phone" placeholder="请输入"></el-input>
            </el-form-item> -->

          </el-form>
          <el-form v-else ref="form" :model="form" :rules="rules" label-width="100px" size="small">
            <el-form-item label="密码" prop="password">
              <el-input style="width:405px;" :type="passwordType" maxlength="100" v-model="form.password" placeholder="请输入">
                <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
              </el-input>
            </el-form-item>
          </el-form>

        </div>
    </template>
    <!-- 按钮 -->
    <template #btns v-if="showBtn">
      <el-button  @click="close">取消</el-button>
      <el-button type="primary" @click="submitForm">提交</el-button>
    </template>
  </Dialogs>
</template>
<script>
import {addCarbonSinkUser,updateCarbonSinkUser,carbonSinkResetPassword} from "@/api/api"
import { Encrypt } from "@/utils/secret.js";
import Dialogs from "@/components/dialogs/dialogs.vue"

export default {
  props:['dialog','handleClose','isView','formData','isPassword'],
  data(){
      return{
          data:{
            size: 720,
            visible: true,
            title: "新增",
          },
          loading:false,
          close:function(){},
          showBtn:false,
          // 提交表单
          form:{
            loginName: "", // 用户名
            name: "", // 姓名
            password: "", // 密码
            phone: "", // 手机号
            sex:'', // 性别 0：女 1：男

          },
        type:[],
          // 校验
          rules:{
            phone:[{ required: true, message: "请输入手机号" },{
            validator: (rule, value, cb) => {
              if (/^1[3-9]\d{9}$/.test(value)) {
                cb();
              } else {
                cb(new Error("手机号格式错误"));
              }
            },
          },],
            password:[{ required: true, message: "请填写密码" },{min:8,message:'密码长度不小于8位'},{max:18,message:'密码长度不大于18位'},{pattern:/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9]{8,18}$/,message:'包括至少1个大写字母，1个小写字母，1个数字'}],

            // password: [{ required: true, message: "请输入密码" }],
          },
          // 是否是修改密码
          isUpdatePassword:false,
          // 密码类型
          passwordType:"password"
      }
  },
  methods:{
    // 提交
    async submitForm(){
      let bol = true;
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          bol = false;
          return false;
        }
      });
      if(bol){
        if(this.isUpdatePassword){
          // 是否是修改密码
          let form = { ...this.form }
          form.key = this.getUUID(16, 62)
          form.password = Encrypt(form.password,form.key,form.key)
          const res = await carbonSinkResetPassword(form)
          if(res.data.code == 200){
            this.data.visible = false
            this.$parent.getList()
            this.$message.success(res.data.message);
          }else{
            this.$message.error(res.data.message);
          }
        }else{
          let form = { ...this.form }
          if(form.id){
            // 有id为修改
            form.isFirstlevel=this.type.indexOf('一级审核')>=0
            form.isTwolevel=this.type.indexOf('审核')>=0
            const res = await updateCarbonSinkUser(form)
            if(res.data.code == 200){
              this.data.visible = false
              this.$parent.getList()
              this.$message.success(res.data.message);
            }else{
              this.$message.error(res.data.message);
            }
          }else{
            // 新增
            form.key = this.getUUID(16, 62)
            form.password = Encrypt(form.password,form.key,form.key)
            form.isFirstlevel=this.type.indexOf('一级审核')>=0
            form.isTwolevel=this.type.indexOf('审核')>=0
            const res = await addCarbonSinkUser(form)
            if(res.data.code == 200){
              this.data.visible = false
              this.$parent.getList()
              this.$message.success(res.data.message);
            }else{
              this.$message.error(res.data.message);
            }
          }
        }
      }
    },
    // 发布类型改变
    changeSelect(val){
    },
    // 显示密码
    showPassword() {
      this.passwordType == "" ?
        (this.passwordType = "password") :
        (this.passwordType = "");
    },
    // 获取随机字符串
    getUUID(len, radix) {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
      var uuid = []
      var i
      radix = radix || chars.length
      if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
      } else {
        var r
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | Math.random() * 16
            uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
          }
        }
      }
      return uuid.join('')
    },
  },
  components:{
    Dialogs,
  },
   watch:{
    dialog:{
      handler(val){
        this.$set(this,'data',val)
        this.$set(this,'passwordType',"password")
      },
      deep:true,
      immediate:true
    },
    handleClose:{
      handler(val){
        this.$set(this,'close',val)
      },
      immediate:true
    },
    isView:{
      handler(val){
        this.$set(this,'showBtn',val)
      },
      immediate:true
    },
    isPassword:{
      handler(val){
        this.$set(this,'isUpdatePassword',val)
      },
      immediate:true
    },
    formData:{
      handler(val){
        this.fileList = []
        if(val.accessory){
          val.accessory = JSON.parse(val.accessory)
          this.fileList = val.accessory
          console.log(this.files);
        }
        this.$set(this,'form',val)
        let type=[]
        if(val.isFirstlevel)
          type.push('一级审核')
        if(val.isTwolevel)
          type.push('审核')
        this.type=type
        this.$nextTick(()=>{
          if(this.$refs.form)
          this.$refs.form.clearValidate();
        })
      },
    },
    // 'form.type':{
    //   handler(val,oldVal){
    //     if(oldVal)
    //       this.fileList = []
    //   },
    //   immediate:true
    // }
  }
}
</script>
<style scoped>
    ::v-deep .inlinitem.el-form-item {
        display: inline-flex;
        justify-content: flex-start;
    }
    ::v-deep .inlinitem.el-form-item .el-form-item__content {
        margin-left: 2px !important;
    }
    .h120 {
        height: 120px;
    }
    ::v-deep .h120 .el-textarea__inner {
        height: 120px;
    }
</style>
